import { useMedia } from "react-use";

export default function useMediaWithInitialState(mediaQuery: string): boolean {
  return useMedia(mediaQuery, window.matchMedia(mediaQuery).matches);
}
